(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import i18n from "i18next";
import translationEN from "../i18n/en.json";
import translationAR from "../i18n/ar.json";
import translationAM from "../i18n/am.json";
import translationBN from "../i18n/bn.json";
const resources = {
  en: {
    translation: translationEN
  },
  ar: {
    translation: translationAR
  },
  am: {
    translation: translationAM
  },
  bn: {
    translation: translationBN
  }
};
const i18nInstance = i18n.createInstance({
  lng: "en",
  debug: false,
  keySeparator: ".",
  fallbackLng: false,
  returnEmptyString: false,
  interpolation: {
    escapeValue: false,
    format: value => value instanceof Date ? value.toISOString() : value
  },
  resources
}, // We must provide a function as second parameter, otherwise i18next errors
err => {
  // eslint-disable-next-line no-console
  if (err) console.log(err);
});
const _default = i18nInstance;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(resources, "resources", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Translation/configs/i18n.js");
  reactHotLoader.register(i18nInstance, "i18nInstance", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Translation/configs/i18n.js");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/modules/Translation/configs/i18n.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();